const height = {
    desktop: 80,
    mobile: 82,
};

export default { height };
